import { Route } from "react-router-dom";
import { ShowProvider } from "../../../providers";
import { MedicineList } from "../Medicine-List/Medicine-List";
import { MedicineMaterials } from "../Medicine-Materials/Medicine-Materials";
import { AntiDopingMaterials } from "../AntiDoping-Materials/AntiDopingMaterials";
import { MedicineSection } from "../Medicine-Section/MedicineSection";
import { MedicineContestYears } from "../Medicine-Contests/MedicineContestYears";
import { MedicineContestYearPage } from "../Medicine-Contests/MedicineContestYearPage";
import { MedicineContestFormPage } from "../Medicine-Contests/MedicineContestFormPage";
import { MedicineConferencePageForm } from "../Medicine-Contests/MedicineConferencePageForm";
import { MedicineDigestFormPage } from "../Medicine-Digests/MedicineDigestFormPage";
import { MedicineAnnouncementFormPage } from "../Medicine-Announcements/MedicineAnnouncementFormPage";

const medicineRoutes = [
  <Route
    key={"medicine"}
    path="medicine"
    element={
      <ShowProvider>
        <MedicineList />
      </ShowProvider>
    }
  />,
  <Route
    key={"medicine-materials"}
    path="medicine/materials"
    element={
      <ShowProvider>
        <MedicineMaterials />
      </ShowProvider>
    }
  />,
  <Route
    key={"medicine-digests-create"}
    path="medicine/materials/digests/create"
    element={
      <ShowProvider>
        <MedicineDigestFormPage />
      </ShowProvider>
    }
  />,
  <Route
    key={"medicine-digests-edit"}
    path="medicine/materials/digests/edit/:id"
    element={
      <ShowProvider>
        <MedicineDigestFormPage />
      </ShowProvider>
    }
  />,
  <Route
    key={"medicine-announcements-create"}
    path="medicine/materials/announcements/create"
    element={
      <ShowProvider>
        <MedicineAnnouncementFormPage />
      </ShowProvider>
    }
  />,
  <Route
    key={"medicine-announcements-edit"}
    path="medicine/materials/announcements/edit/:id"
    element={
      <ShowProvider>
        <MedicineAnnouncementFormPage />
      </ShowProvider>
    }
  />,
  <Route
    key={"medicine-section"}
    path="medicine/section"
    element={
      <ShowProvider>
        <MedicineSection />
      </ShowProvider>
    }
  />,
  <Route
    key={"medicine-contests"}
    path="medicine/contests"
    element={
      <ShowProvider>
        <MedicineContestYears openSingleItem />
      </ShowProvider>
    }
  />,
  <Route
    key={"medicine-contests-create"}
    path="medicine/contests/create"
    element={
      <ShowProvider>
        <MedicineContestFormPage />
      </ShowProvider>
    }
  />,
  <Route
    key={"medicine-contests-year-create"}
    path="medicine/contests/:year/create"
    element={
      <ShowProvider>
        <MedicineContestFormPage />
      </ShowProvider>
    }
  />,
  <Route
    key={"medicine-contests-year-edit"}
    path="medicine/contests/:year/edit/:id"
    element={
      <ShowProvider>
        <MedicineContestFormPage />
      </ShowProvider>
    }
  />,
  <Route
    key={"medicine-contests-year"}
    path="medicine/contests/:year"
    element={
      <ShowProvider>
        <MedicineContestYearPage singleItemPerYear />
      </ShowProvider>
    }
  />,
  <Route
    key={"medicine-conferences"}
    path="medicine/conferences"
    element={
      <ShowProvider>
        <MedicineContestYears
          contestType="CONFERENCE"
          basePath="/medicine/conferences"
          title="Конференции"
          createButtonText="Создать конференцию"
          openSingleItem
        />
      </ShowProvider>
    }
  />,
  <Route
    key={"medicine-conferences-page"}
    path="medicine/conferences/page"
    element={
      <ShowProvider>
        <MedicineConferencePageForm />
      </ShowProvider>
    }
  />,
  <Route
    key={"medicine-conferences-create"}
    path="medicine/conferences/create"
    element={
      <ShowProvider>
        <MedicineContestFormPage
          contestType="CONFERENCE"
          basePath="/medicine/conferences"
          createTitle="Создание конференции"
          editTitle="Редактирование конференции"
          entityName="Конференция"
          titlePlaceholder="Медицинская конференция"
        />
      </ShowProvider>
    }
  />,
  <Route
    key={"medicine-conferences-year-create"}
    path="medicine/conferences/:year/create"
    element={
      <ShowProvider>
        <MedicineContestFormPage
          contestType="CONFERENCE"
          basePath="/medicine/conferences"
          createTitle="Создание конференции"
          editTitle="Редактирование конференции"
          entityName="Конференция"
          titlePlaceholder="Медицинская конференция"
        />
      </ShowProvider>
    }
  />,
  <Route
    key={"medicine-conferences-year-edit"}
    path="medicine/conferences/:year/edit/:id"
    element={
      <ShowProvider>
        <MedicineContestFormPage
          contestType="CONFERENCE"
          basePath="/medicine/conferences"
          createTitle="Создание конференции"
          editTitle="Редактирование конференции"
          entityName="Конференция"
          titlePlaceholder="Медицинская конференция"
        />
      </ShowProvider>
    }
  />,
  <Route
    key={"medicine-conferences-year"}
    path="medicine/conferences/:year"
    element={
      <ShowProvider>
        <MedicineContestYearPage
          contestType="CONFERENCE"
          basePath="/medicine/conferences"
          title="Конференции"
          addButtonText="Добавить конференцию"
          entityName="Конференция"
          emptyText="Конференции отсутствуют"
          singleItemPerYear
        />
      </ShowProvider>
    }
  />,
  <Route
    key={"medicine-anti-doping-materials"}
    path="medicine/anti-doping/materials"
    element={
      <ShowProvider>
        <AntiDopingMaterials />
      </ShowProvider>
    }
  />,
];

export const MEDICINE_ROUTES = medicineRoutes.map((route) => route);
